import {
  capitalize,
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material';
import clsx from 'clsx';
import { IconContext, IconProps } from 'phosphor-react';

import { Sizes } from '../../types';

export type ToggleButtonGroupSize = Sizes<'sm' | 'md' | 'lg'>;

const getIconProps = (size: ToggleButtonGroupSize): IconProps => {
  switch (size) {
    case 'sm':
      return {
        size: '15px',
        weight: 'regular',
      };
    case 'lg':
      return {
        size: '20px',
        weight: 'bold',
      };
    default:
      return {
        size: '20px',
        weight: 'bold',
      };
  }
};

type ToggleButtonGroupProps = Omit<MuiToggleButtonGroupProps, 'size'> & {
  allowUnselect?: boolean;
  size?: ToggleButtonGroupSize;
  testId?: string;
};

export const ToggleButtonGroup = ({
  children,
  className,
  size = 'md',
  exclusive = true,
  allowUnselect,
  onChange,
  testId,
  ...props
}: ToggleButtonGroupProps) => {
  return (
    <IconContext.Provider value={getIconProps(size)}>
      <MuiToggleButtonGroup
        {...props}
        size={size}
        className={clsx(
          className,
          `MuiToggleButtonGroup-size${capitalize(size)}`
        )}
        exclusive={exclusive}
        onChange={
          allowUnselect
            ? onChange
            : (event, val) => {
                if (val !== null) {
                  onChange?.(event, val);
                }
              }
        }
        data-testid={testId}
      >
        {children}
      </MuiToggleButtonGroup>
    </IconContext.Provider>
  );
};
